/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Coinvestment_Title1Inputs */

const en_settings_coinvestment_title1 = /** @type {(inputs: Settings_Coinvestment_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-investment`)
};

/**
* | output |
* | --- |
* | "Co-investment" |
*
* @param {Settings_Coinvestment_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_coinvestment_title1 = /** @type {((inputs?: Settings_Coinvestment_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Coinvestment_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_coinvestment_title1(inputs)
});
export { settings_coinvestment_title1 as "settings_coInvestment_title" }